
export const heroOne = {
	id: 'projects',
	topLine: {
		text: 'computer graphic design',
	},
	headline: 'Raytracing',
	description:
		"Following Rtv1, RT pushes the possibilities of Raytracing much further: mirror effect, transparency, cutting of objects, applications of textures.",	buttonLabel: 'View Project',
	imgStart: 'start',
	linkTo: 'https://github.com/a-str-o/RT',
	img: './images/content/Ray.png',
	backgroundColor: 'linear-gradient(	150deg,#20083f -20%,#222463)',
	start: 'true',
};

export const heroTwo = {
	reverse: true,
	topLine: {
		text: 'Development and Design',
	},
	headline: 'Beautiful Landing Page for Lifecycle',
	description: "Landing pages are called that, precisely because they tend to be the first point of contact for users with your brand, lets create the best for your page",
	buttonLabel: 'View Project',

	linkTo: 'https://github.com/a-str-o?tab=repositories',
	imgStart: 'start',
	img: './images/content/landing-page.svg',
	backgroundColor: 'linear-gradient(	140deg	,#ffaf73 30%,#fffecc 120%)',

	start: 'true',
};

export const heroThree = {
	topLine: {
		text: 'Development',
	},
	headline: "Innovative API's ",
	description:
		'I can that can turn any design sketches and ideas into a fully functioning product.',
	buttonLabel: 'View Project',
	linkTo: 'https://github.com/a-str-o?tab=repositories',
	imgStart: '',
	backgroundColor: 'linear-gradient(104deg, rgba(151,147,218,1) 0%, rgba(183,137,205,1) 100%)',
	img: './images/content/lost.svg',
	start: 'true',
};

export const heroFour = {
	reverse: true,
	topLine: {
		text: 'Web app',
	},
	headline: 'Mern ecommerce app',
	description: 'MERN Stack is an umbrella term used for MongoDB, Express, React and Node.js. MERN stack is an open-source full-stack JavaScript solution used for faster and easier development and deployment of full-stack applications. MERN is designed to make the process of application development swift and simple.',
	buttonLabel: 'View Project',
	linkTo: 'https://github.com/a-str-o?tab=repositories',
	imgStart: '',
	backgroundColor: 'linear-gradient(225deg,#0abac2,#b2de94)',
	img: './images/content/ecommerce.svg',
	start: 'true',
};
export const herosix = {
	reverse: false,
	topLine: {
		text: 'streaming service',
	},
	headline: 'TV shows, movies',
	description: 'Unlimited movies, TV shows, and more.',
	buttonLabel: 'Watch now',
	linkTo: 'https://moviekech.netlify.app/',
	imgStart: '',
	backgroundColor: '#BF714A',
	img: './images/content/movie.png',
	start: 'true',
};
export const heroseven = {
	reverse: true,
	topLine: {
		text: 'laravel',
	},
	headline: 'laravel 11 with mysql tailwind css',
	description: 'crud ticket',
	buttonLabel: 'VIEW PROJECT',
	linkTo: 'https://github.com/a-str-o/laravel',
	imgStart: '',
	backgroundColor: '#F43B3D',
	img: './images/content/laravel.jpg',
	start: 'true',
};

export const hero8 = {
	reverse: false,
	topLine: {
		text: 'Invoice',
	},
	headline: 'Create Invoice',
	description: 'invoice system',
	buttonLabel: 'VIEW PROJECT',
	linkTo: 'https://github.com/a-str-o/Invoice',
	imgStart: 'start',
	backgroundColor: '#2B67EB',
	img: './images/content/invoice.png',
	start: 'true',
};
